import { render } from "./AboutApp.vue?vue&type=template&id=3cd49904&ts=true"
import script from "./AboutApp.vue?vue&type=script&lang=ts"
export * from "./AboutApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__